import { inject, Injectable } from '@angular/core';
import { DalState, getRouterState, RouterStateUrl, SettingsPermissions } from '@campus/dal';

import { RouterReducerState } from '@ngrx/router-store';
import { Store } from '@ngrx/store';
import { combineLatest, Observable } from 'rxjs';
import { map, shareReplay } from 'rxjs/operators';
import { PermissionService } from '../../auth';

@Injectable({
  providedIn: 'root',
})
export class AppShellService {
  private permissionService = inject(PermissionService);
  private store: Store<DalState> = inject(Store);
  private routerState$: Observable<RouterReducerState<RouterStateUrl>>;
  private hasV2Permission$: Observable<boolean>;

  public deniedV2Access$: Observable<boolean>;
  public allowedV2Access$: Observable<boolean>;

  public isOnV1Route$: Observable<boolean>;
  public isOnV2Route$: Observable<boolean>;

  constructor() {
    this.hasV2Permission$ = this.permissionService.hasPermission$(SettingsPermissions.APP_SHELL_V2);
    this.routerState$ = this.store.select(getRouterState);

    this.allowedV2Access$ = this._isV2Allowed$();
    this.deniedV2Access$ = this.allowedV2Access$.pipe(map((allowed) => !allowed));

    this.isOnV2Route$ = this._isV2Route$();
    this.isOnV1Route$ = this._isV2Route$().pipe(map((isV2Route) => !isV2Route));
  }

  private _isV2Allowed$(): Observable<boolean> {
    return this.hasV2Permission$.pipe(
      map((hasV2Permission) => hasV2Permission),
      shareReplay({ refCount: true, bufferSize: 1 })
    );
  }

  private _isV2Route$(): Observable<boolean> {
    return combineLatest([this.routerState$, this.allowedV2Access$]).pipe(
      map(([routerState, hasV2Permission]) => routerState?.state?.url?.includes('/v2') && hasV2Permission),
      shareReplay({ refCount: true, bufferSize: 1 })
    );
  }
}
